import { createApiRef } from '@backstage/core-plugin-api';
import { CreateDatabasePipeline } from './dto/request/createdatabase';
import { CreateDatabaseRoot } from './dto/response/createdatabase';
import { GetDatabaseStatusRoot } from './dto/response/getdatabasestatus';
import { GetPipelineLog } from './dto/response/get-pipeline-log.response';

export interface DatabaseApi {
    getDatabaseStatus: (environment: string, system_name: string, application_name: string) => Promise<GetDatabaseStatusRoot>;
    createDatabase: (environment: string, system_name: string, body: CreateDatabasePipeline) => Promise<CreateDatabaseRoot>;
    getPipelineLog: (environment: string, system_name: string, application_name: string, pipeline_id: number) => Promise<GetPipelineLog>;

}

export const DatabaseApiRef = createApiRef<DatabaseApi>({
    id: 'plugin.database-api.service'
})